module.exports = __webpack_public_path__ + "img/jardine-albertyn.bb42d4a1.png";